module.exports = __webpack_public_path__ + "media/images/japan/nav_4-e139fddd6b0fe556007dc784002111ed.svg";